/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 出荷可能フラグ（火曜日）
 * @export
 * @interface EnableShipdayTue
 */
export interface EnableShipdayTue {
}

/**
 * Check if a given object implements the EnableShipdayTue interface.
 */
export function instanceOfEnableShipdayTue(value: object): value is EnableShipdayTue {
    return true;
}

export function EnableShipdayTueFromJSON(json: any): EnableShipdayTue {
    return EnableShipdayTueFromJSONTyped(json, false);
}

export function EnableShipdayTueFromJSONTyped(json: any, ignoreDiscriminator: boolean): EnableShipdayTue {
    return json;
}

export function EnableShipdayTueToJSON(json: any): EnableShipdayTue {
    return EnableShipdayTueToJSONTyped(json, false);
}

export function EnableShipdayTueToJSONTyped(value?: EnableShipdayTue | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

